
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../button/Button'

const EmptyState = ({ title, description, thumbSrc, buttonText, callbackBtn, className }) => {
  const classContainer = classNames('empty-state', className, {
  })

  const propBtn = () => ({
    kind: 'none',
    className: 'empty-state_button cursor-pointer',
    onClick: callbackBtn
  })

  return (

    <div className={classContainer}>
      {thumbSrc &&
        <div className='frontend-row'>
          <div className='col-xs-2 col-xs-offset-5'>
            <div className='thumb-container'>
              <img src={thumbSrc} />
            </div>
          </div>
        </div>}
      <div className='frontend-row m-top'>
        <div className='col-xs-12 text-center'>
          {title && <h3>{title}</h3>}
          {description && <p>{description}</p>}
        </div>
      </div>
      {buttonText &&
        <div className='frontend-row m-top-thirty text-center'>
          <div className='col-xs-12'>
            {buttonText &&
              <Button {...propBtn()}>{buttonText}</Button>}
          </div>
        </div>}
    </div>

  )
}

EmptyState.defaultProps = {
  buttonText: ''
}

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  thumbSrc: PropTypes.string,
  buttonText: PropTypes.string,
  callbackBtn: PropTypes.func,
  className: PropTypes.string
}

export default EmptyState
